import { browserHistory } from "react-router";

import { HOST_HUB_TAB_PATHS } from "../../app-host-hub/constants/host-hub.consts";
import type { HostHubNavTabId } from "../../app-host-hub/types/host-hub.types";

/** Pushes the next tab path to history, skipping if it's already active. */
export const navigateToHostHubTab = (
  nextTabId: HostHubNavTabId,
  currentTabId: HostHubNavTabId,
): void => {
  if (nextTabId !== currentTabId) {
    browserHistory.push(HOST_HUB_TAB_PATHS[nextTabId]);
  }
};
